import { TreeView } from "@mui/x-tree-view/TreeView";
import {
  TreeItem,
} from "@mui/x-tree-view/TreeItem";
import { Icon } from "@mui/material";
import { useState } from "react";

interface Props {
  pillars: any;
  setEditMode: any;
  editMode: string;
  setCreateMode: any;
  createMode: string;
  currentId: any;
  setCurrentId: any;
  handleDelete: any;
  expanded: any;
  setExpanded: any;
  setIsSnackbarOpen: any;
}

export const PillarTree = (props: Props) => {
  const {
    pillars,
    setCreateMode,
    createMode,
    setEditMode,
    currentId,
    setCurrentId,
    handleDelete,
    expanded,
    setExpanded,
    setIsSnackbarOpen,
  } = props;

  const [selectedId, setSelectedId] = useState("");

  const handleToggle = (event: React.SyntheticEvent, nodeIds: string[]) => {
    setExpanded(nodeIds);
  };

  const handleNodeSelect = (event: React.SyntheticEvent, nodeId: string) => {
    setExpanded([nodeId]);
    setIsSnackbarOpen(false);
  };

  const AddBoxIcon = (props: any) => {
    const color =
      props.bgColor?.match(
        /(rgb\(\d{1,3}, \d{1,3}, \d{1,3}\)|#[0-9a-fA-F]{6})/
      )?.[0] || "";
    // const textColor =
    return (
      <Icon fontSize="small" style={{ color: color || "" }}>
        add_box_icon
      </Icon>
    );
  };
  const AddOutlineIcon = (props: any) => {
    const color =
      props.bgColor?.match(
        /(rgb\(\d{1,3}, \d{1,3}, \d{1,3}\)|#[0-9a-fA-F]{6})/
      )?.[0] || "";
    // const textColor =
    return (
      <Icon fontSize="small" style={{ color: color || "" }}>
        add_icon
      </Icon>
    );
  };
  const CloseBoxIcon = (props: any) => {
    const color =
      props.bgColor?.match(
        /(rgb\(\d{1,3}, \d{1,3}, \d{1,3}\)|#[0-9a-fA-F]{6})/
      )?.[0] || "";

    return (
      <Icon fontSize="small" style={{ color: color || "" }}>
        indeterminate_check_box_icon
      </Icon>
    );
  };

  const CloseOutlineIcon = (props: any) => {
    const color =
      props.bgColor?.match(
        /(rgb\(\d{1,3}, \d{1,3}, \d{1,3}\)|#[0-9a-fA-F]{6})/
      )?.[0] || "";

    return (
      <Icon fontSize="small" style={{ color: color || "" }}>
        remove_icon
      </Icon>
    );
  };
  return (
    <div
      // className="visible-scrollbar"
      style={{
        minHeight: "95vh",
        maxHeight: "100vh",
        flexGrow: 1,
        maxWidth: "50%",
        minWidth: "50%",
        background: "#eef5fd",
        margin: "4px 0px 4px 4px",
        padding: "0 10px",
        overflow: "auto",
      }}
    >
      <TreeView
        expanded={expanded}
        onNodeToggle={handleToggle}
        onNodeSelect={handleNodeSelect}
      >
        {pillars?.sort((a: any, b: any) => a?.title?.localeCompare(b?.title)).map((pillar: any) => (
          <TreeItem // pillar branch
            onClick={() => {
              setSelectedId(pillar.id);
              setCreateMode("Subdomain");
              setEditMode("Pillar");
              setCurrentId({ ...currentId, pillar_id: pillar.id });
              expanded?.[0] === pillar.id
                ? setExpanded([])
                : setExpanded([pillar.id]);
            }}
            sx={{ margin: 1 }}
            key={pillar.id}
            nodeId={pillar.id}
            label={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {pillar.title}
                {selectedId === pillar.id && (
                  <Icon
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete("pillar", pillar.id);
                    }}
                    className="delete_button"
                  >
                    delete_icon
                  </Icon>
                )}
              </div>
            }
            icon={
              <Icon
                style={{
                  color: "white",
                  background: pillar?.graphics?.iconbg,
                  borderRadius: 100,
                  padding: 8,
                  marginRight: 18,
                }}
              >
                {pillar?.graphics?.icon}
              </Icon>
            }
          >
            {pillar?.subdomains
              ?.sort((a: any, b: any) => a?.title?.localeCompare(b?.title))
              .map((subdomain: any) => (
                <TreeItem // subdomain branch
                  onClick={() => {
                    setSelectedId(subdomain.id);
                    setCreateMode("Knowledge Area");
                    setEditMode("Subdomain");
                    setCurrentId({
                      ...currentId,
                      pillar_id: pillar.id,
                      subdomain_id: subdomain.id,
                    });
                    expanded?.[1] === subdomain.id
                      ? setExpanded([pillar.id])
                      : setExpanded([pillar.id, subdomain.id]);
                  }}
                  key={subdomain.id}
                  nodeId={subdomain.id}
                  label={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      {subdomain.title}
                      {selectedId === subdomain.id && (
                        <Icon
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDelete("subdomain", subdomain.id);
                          }}
                          className="delete_button"
                        >
                          delete_icon
                        </Icon>
                      )}
                    </div>
                  }
                  collapseIcon={
                    <CloseBoxIcon
                      bgColor={pillar?.graphics?.iconbg || "rgb(0, 0, 0)"}
                    />
                  }
                  expandIcon={
                    <AddBoxIcon
                      bgColor={pillar?.graphics?.iconbg || "rgb(0, 0, 0)"}
                    />
                  }
                  endIcon={
                    <Icon
                      fontSize="small"
                      style={{
                        color:
                          pillar?.graphics?.iconbg?.match(
                            /(rgb\(\d{1,3}, \d{1,3}, \d{1,3}\)|#[0-9a-fA-F]{6})/
                          )?.[0] || "",
                        fontSize: 20,
                      }}
                    >
                      forward_icon
                    </Icon>
                  }
                >
                  {subdomain?.knowledge_areas
                    ?.sort((a: any, b: any) =>
                      a?.title?.localeCompare(b?.title)
                    )
                    .map((ka: any) => (
                      <TreeItem // knowledge area branch
                        onClick={() => {
                          setSelectedId(ka.id);
                          setCreateMode("Knowledge Topic");
                          setEditMode("Knowledge Area");
                          setCurrentId({
                            ...currentId,
                            pillar_id: pillar.id,
                            subdomain_id: subdomain.id,
                            area_id: ka.id,
                          });
                          expanded?.[2] === ka.id
                            ? setExpanded([pillar.id, subdomain.id])
                            : setExpanded([pillar.id, subdomain.id, ka.id]);
                        }}
                        key={ka.id}
                        nodeId={ka.id}
                        label={
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            {ka.title}
                            {selectedId === ka.id && (
                              <Icon
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDelete("knowledgeArea", ka.id);
                                }}
                                className="delete_button"
                              >
                                delete_icon
                              </Icon>
                            )}
                          </div>
                        }
                        collapseIcon={
                          <CloseOutlineIcon
                            bgColor={pillar?.graphics?.iconbg || "rgb(0, 0, 0)"}
                          />
                        }
                        expandIcon={
                          <AddOutlineIcon
                            bgColor={pillar?.graphics?.iconbg || "rgb(0, 0, 0)"}
                          />
                        }
                        endIcon={
                          <Icon
                            fontSize="small"
                            style={{
                              color:
                                pillar?.graphics?.iconbg?.match(
                                  /(rgb\(\d{1,3}, \d{1,3}, \d{1,3}\)|#[0-9a-fA-F]{6})/
                                )?.[0] || "",
                              fontSize: 20,
                            }}
                          >
                            forward_icon
                          </Icon>
                        }
                      >
                        {ka?.knowledge_topics
                          ?.sort((a: any, b: any) =>
                            a?.title?.localeCompare(b?.title)
                          )
                          .map((topic: any) => (
                            <TreeItem
                              onClick={() => {
                                setSelectedId(topic.id);
                                setCreateMode("");
                                setEditMode("Knowledge Topic");
                                setExpanded([
                                  pillar.id,
                                  subdomain.id,
                                  ka.id,
                                  topic.id,
                                ]);
                                setCurrentId({
                                  ...currentId,
                                  pillar_id: pillar.id,
                                  subdomain_id: subdomain.id,
                                  area_id: ka.id,
                                  topic_id: topic.id,
                                });
                              }}
                              key={topic.id}
                              nodeId={topic.id}
                              label={
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  {topic.title}
                                  {selectedId === topic.id && (
                                    <Icon
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleDelete(
                                          "knowledgeTopic",
                                          topic.id
                                        );
                                      }}
                                      className="delete_button"
                                    >
                                      delete_icon
                                    </Icon>
                                  )}
                                </div>
                              }
                              icon={
                                <Icon
                                  fontSize="small"
                                  style={{
                                    color:
                                      pillar?.graphics?.iconbg?.match(
                                        /(rgb\(\d{1,3}, \d{1,3}, \d{1,3}\)|#[0-9a-fA-F]{6})/
                                      )?.[0] || "",
                                    fontSize: 10,
                                  }}
                                >
                                  circle_icon
                                </Icon>
                              }
                              collapseIcon={
                                <CloseOutlineIcon
                                  bgColor={
                                    pillar?.graphics?.iconbg || "rgb(0, 0, 0)"
                                  }
                                />
                              }
                              expandIcon={
                                <AddOutlineIcon
                                  bgColor={
                                    pillar?.graphics?.iconbg || "rgb(0, 0, 0)"
                                  }
                                />
                              }
                            />
                          ))}
                      </TreeItem>
                    ))}
                </TreeItem>
              ))}
          </TreeItem>
        ))}
      </TreeView>
    </div>
  );
};
